import { apiDuoauthOauthLinkAuthorize } from '@/api'
import { dcb } from '@dcb/jssdk'
import { devOrProd } from './dev_or_prod'
import { submit } from './submit'

export const contactCustomerService = () => {
  submit(async $ => {
    $.start()
    const url = devOrProd(
      'https://uni-h5.duotest.cn/app/duoduo-kefu-h5/#/qa?isFull=true&isAuth=true&isLogin=true&sceneId=1772186170410094593',
      'https://uni-h5.gogpay.cn/app/duoduo-kefu-h5/#/qa?isFull=trueisAuth=true&isLogin=true&sceneId=1774775820931637249',
    )
    const res = await apiDuoauthOauthLinkAuthorize({
      required: true,
      state: 'link_redirect',
      url: url,
    })
    dcb.navigateTo({ url: res.url! })
  })
  // showActionSheet([
  //   {
  //     label: '在线客服',
  //     onClick: () => {
  //       submit(async $ => {
  //         $.start()
  //         const url = devOrProd(
  //           'https://uni-h5.duotest.cn/app/duoduo-kefu-h5/#/qa?isFull=true&isAuth=true&isLogin=true&sceneId=1772186170410094593',
  //           'https://uni-h5.gogpay.cn/app/duoduo-kefu-h5/#/qa?isFull=trueisAuth=true&isLogin=true&sceneId=1774775820931637249',
  //         )
  //         const res = await apiDuoauthOauthLinkAuthorize({
  //           required: true,
  //           state: 'link_redirect',
  //           url: url,
  //         })
  //         dcb.navigateTo({ url: res.url! })
  //       })
  //     },
  //   },
  //   {
  //     label: '电话客服',
  //     onClick: () => {
  //       dcb.makePhoneCall({
  //         phoneNumber: '4009008799',
  //       })
  //     },
  //   },
  // ])
}
